import React from 'react';
import { useState } from "react";

function Button(props = {}) {
    let state = {

    };
    state = {...state, ...props.options};
    const [NoOfClicks, SetClicksCount] = useState(0);
    function UpdateAndAlertTheClicks(e) {
        SetClicksCount(NoOfClicks + 1);
        if(typeof props.onClick ==="function"){
            props.onClick(e);
        }
    }
    return (
        <input type="button" value={props.value} onClick={UpdateAndAlertTheClicks} className={props.className} style={props.style} ></input>
  );
}

export default Button;